var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33203 4.66666C5.33203 4.66666 6.7959 2.8559 7.60163 2.15926C7.73116 2.04726 7.87663 1.99434 8.02116 2.00048C8.15083 2.00598 8.2797 2.05896 8.3959 2.15941C9.20143 2.85618 10.6654 4.66666 10.6654 4.66666M8.02116 2.66666V10",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33464 7.33203C4.40122 7.33203 3.9345 7.33203 3.57798 7.5137C3.26438 7.6735 3.00942 7.92843 2.84962 8.24203C2.66797 8.59856 2.66797 9.0653 2.66797 9.9987V10.6654C2.66797 12.2367 2.66797 13.0224 3.15612 13.5106C3.64428 13.9987 4.42996 13.9987 6.0013 13.9987H10.0013C11.5726 13.9987 12.3583 13.9987 12.8465 13.5106C13.3346 13.0224 13.3346 12.2367 13.3346 10.6654V9.9987C13.3346 9.0653 13.3346 8.59856 13.153 8.24203C12.9932 7.92843 12.7382 7.6735 12.4246 7.5137C12.0681 7.33203 11.6014 7.33203 10.668 7.33203",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.30312c14b62fae9e0562ee654e187bab.svg";
export { ForwardRef as ReactComponent };